<style lang="scss">
.finish-btn {
  width: 265px;
  height: 36px;
  background: #FF4158;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  color: #FFFFFF;
  border: 0;
  margin-top: 10px;
}

.exp-wrapper {
  //position: absolute;
  //left: 0;
  //top: 46px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 20px;
  background: #fff;
}

.exp-line-title {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  margin-top: 0.10rem ;
}

.exp-line-status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 400;

  color: #3b5998;
}




.finish-panel {
  .panel-title {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 15px;
  }

  .panel-content {
    padding: 15px;
  }

}
.wrap{
  display:flex;
  flex-direction:column;
  height:100%;
}
.footer{
  height:40px;
  width: 100%;
  position: fixed;
  bottom:0;
  left:0;
}
.app-header {
  height: 46px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  //border-bottom: solid 1px rgba(0, 0, 0, 0.03);
  //box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.08);
  z-index: 2;

  font-size: 16px;
  color: #000;
  font-weight: bold;
}

.header-left, .header-right {
  height: 100%;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

}

.header-left {
  left: 0;
}

.header-right {
  right: 0;
}
.icon-left {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
}

.go-home {
  display: block;
  width: 21px;
  height: 19px;
  background: url("../assets/images/go-home.png");
  background-size: contain;
}

</style>
<template>
  <div>

    <div class="app-header" >
      事件响应
      <div class="header-left" @click="$router.push({path:'/'})"><i class="iconfont icon-prev"></i></div>
      <div class="header-right" @click="goHome()"><i class="go-home"></i></div>
    </div>
    <Panel class="tabs" :title="false">
      <div slot="content" class="status-content wrap" v-infinite-scroll="loadEventFeedback"
           infinite-scroll-disabled="loading"
           infinite-scroll-distance="10">
        <div class="line" v-for="(ef,idx) of eventFeedback">
          <router-link style="color: #1f1f1f" :to="{name:'addEventFeedback',query:{eventFeedbackId:ef.id}}">
            <div class="flex-dir-row" style="color: #000000">
              {{ ef.feedbackDate}}
              <div class="flex-item-auto exp-line-status">
                {{ef.eventTypeName}}
              </div>
            </div>
            <div class="flex-dir-row  exp-line-title">{{ef.feedbackUserName}}</div>
          </router-link>
        </div>
        <div class="line text-center" v-if="eventFeedback.length===0">暂无记录</div>
      </div>
    </Panel>
    <div class="btn  green footer" @click="addEventFeedback">新增响应事件</div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import {InfiniteScroll} from 'mint-ui';
import {Toast, MessageBox} from 'mint-ui';
import Panel from "@/components/Panel";
import dict from "@/plugins/dict";

export default {
  components: {
    Panel,
    AppHeader,
    InfiniteScroll
  },
  data() {
    return {
      page: 1,
      eventFeedback: [],
      loading: false,
      noMore: false,
      curExp: null,
      popupVisible: false,
      finalAccounts: false
    }
  },
  mounted() {
    this.initEventFeedback()
    dict.init()
  },
  methods: {
    initEventFeedback() {
      this.eventFeedback = []
      this.page = 1
      this.noMore = false
      this.loadEventFeedback()
    },
    loadEventFeedback() {
      if (this.noMore) {
        return
      }
      const that = this
      this.loading = true
      let data = new FormData()
      data.append('page', `${this.page}`)
      data.append('limit', '10')
      this.$http.post(`/api/eventFeedback/list`, data).then(res => {
        if (res.data && res.data.length > 0) {
          console.log("list",data)
          const eventFeedback = res.data
          that.eventFeedback = that.eventFeedback.concat(eventFeedback)
          that.loading = false
          that.page = that.page + 1
        } else {
          this.noMore = true
        }
      })
    },


    formatDate(date) {
      return this.$moment(date).format('YYYY.MM.DD HH:mm')
    },

    doScore(exp) {
      this.$router.push({
        path: '/exp-score',
        query: {
          id: exp.id
        }
      })
    },
    goHome() {
      this.$router.push("/")
    },

    addEventFeedback(){
      this.$router.push({
        path: '/addEventFeedback',

      })
    }
  }

}
</script>
